import { render, staticRenderFns } from "./KeyInput.vue?vue&type=template&id=60da50a4&scoped=true&"
import script from "./KeyInput.vue?vue&type=script&lang=js&"
export * from "./KeyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60da50a4",
  null
  
)

export default component.exports